export const TSHIRT_SIZES = [
  { value: "XXS", label: "XXS" },
  { value: "XS", label: "XS" },
  { value: "S", label: "S" },
  { value: "M", label: "M" },
  { value: "L", label: "L" },
  { value: "XL", label: "XL" },
  { value: "2XL", label: "2XL" },
  { value: "3XL", label: "3XL" },
  { value: "4XL", label: "4XL" },
];

export const SHOE_SIZES = [
  { value: "5", label: "UK 5 / EU 38" },
  { value: "6", label: "UK 6 / EU 39" },
  { value: "7", label: "UK 7 / EU 41" },
  { value: "8", label: "UK 8 / EU 42" },
  { value: "9", label: "UK 9 / EU 43" },
  { value: "10", label: "UK 10 / EU 45" },
  { value: "11", label: "UK 11 / EU 46" },
  { value: "12", label: "UK 12 / EU 47" },
  { value: "13", label: "UK 13 / EU 48" },
];

export const TROUSER_SIZES = [
  { value: "28", label: "Waist 28" },
  { value: "30", label: "Waist 30" },
  { value: "32", label: "Waist 32" },
  { value: "34", label: "Waist 34" },
  { value: "36", label: "Waist 36" },
  { value: "38", label: "Waist 38" },
  { value: "40", label: "Waist 40" },
  { value: "42", label: "Waist 42" },
  { value: "44", label: "Waist 44" },
]
